import axios from "axios";
import { UserProfile } from "store/app/types";
import { BACKEND_URL } from "./config";

export const passwordlessSignup = async (email: string) => {
  try {
    const response = await axios.request({
      method: "post",
      url: `${BACKEND_URL}/passwordless/send-link`,
      data: {
        email,
      }
    });
    return response.data;
  } catch (err:any) {
    throw err;
  }
};

export const passwordlessLogin = async (
  loginToken: string
) => {
  try {
    const response = await axios.request({
      method: "get",
      url: `${BACKEND_URL}/passwordless/login?loginToken=${loginToken}`,
    });
    return response.data;
  } catch (err:any) {
    throw err;
  }
};

export const getCurrentUser = async (jwt: string) => {
  try {
    const response = await axios.request({
      method: "get",
      url: `${BACKEND_URL}/users/me`,
      headers: {
        Authorization: "Bearer " + jwt,
      },
    });
    return response.data;
  } catch (err:any) {
    throw err;
  }
};

export const login = async (identifier:string, password:string) => {
  try {
    const response = await axios.request({
      method: "post",
      url: `${BACKEND_URL}/auth/local`,
      data: {
        identifier: identifier,
        password: password,
      }
    });
    return response.data;
  } catch (err:any) {
    throw err;
  }
};

export const signup = async (email:string, password:string) => {
  try {
    const response = await axios.request({
      method: "post",
      url: `${BACKEND_URL}/auth/local/register`,
      data: {
        username: generateUsername(),
        email,
        password,
      },
    });
    return response.data;
  } catch (err:any) {
    throw err;
  }
};

export const forgot = async (email:string) => {
  try {
    const response = await axios({
      method: "post",
      url: `${BACKEND_URL}/auth/forgot-password`,
      data: {
        email: email,
      },
    });
    return response.data;
  } catch (err:any) {
    throw err;
  }
};

export const reset = async (code:string, password:string) => {
  try {
    const response = await axios({
      method: "post",
      url: `${BACKEND_URL}/auth/reset-password`,
      data: {
        code: code,
        password: password,
        passwordConfirmation: password,
      },
    });
    return response.data;
  } catch (err:any) {
    throw err;
  }
};

export const updateProfile = async (jwt: string, data: any, id: number) => {
  try {
    const response = await axios({
      method: "put",
      url: `${BACKEND_URL}/profiles/${id}`,
      data,
      headers: {
        Authorization: "Bearer " + jwt,
      },
    });
    return response.data;
  } catch (err:any) {
    throw err;
  }
};

export const changePassword = async (jwt: string, password: string, id: number) => {
  try {
    let response = await axios({
      method: "put",
      url: `${BACKEND_URL}/users/${id}`,
      headers: {
        Authorization: "Bearer " + jwt,
      },
      data: {
        password: password,
      },
    });
    return response.data;
  } catch (err:any) {
    throw err;
  }
};

function generateUsername() {
  const adjectives = ['happy', 'sleepy', 'silly', 'goofy', 'grumpy', 'cheerful', 'mysterious', 'bouncy'];
  const nouns = ['penguin', 'giraffe', 'elephant', 'kangaroo', 'koala', 'llama', 'narwhal', 'panda'];
  const randomAdjective = adjectives[Math.floor(Math.random() * adjectives.length)];
  const randomNoun = nouns[Math.floor(Math.random() * nouns.length)];
  const randomNum = Math.floor(Math.random() * 100);
  return `${randomAdjective}-${randomNoun}-${randomNum}`;
}